<template>
  <div class="comingSoon">
    <div class="container">
      <h1>网站建设中，敬请期待……</h1>
      <img src="../assets/img/comingsoon.svg" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name:'comingSoon'
}
</script>
<style lang="scss">
.comingSoon{
  text-align: center;
  min-height: 100%;
  h1{
    font-size: 30px;
    margin: 120px 0 30px 0;
  }
}
</style>
